module.exports = __webpack_public_path__ + "static/media/TP_Icon_Single.1ff1f835.png";